import { Component, OnInit } from '@angular/core'
import { AuthenticationService } from '../../../_services/authentication.service'
import { RequestsService } from '../../../_shared/services/requests.service'
import { HelperFunctions } from '../../../_shared/utils/helper-functions'

declare var jQuery: any

@Component({
  selector: 'app-videos',
  templateUrl: './videos.component.html',
  styleUrls: ['./videos.component.scss'],
})
export class VideosComponent implements OnInit {
  constructor(
    private authenticationService: AuthenticationService,
    private requestService: RequestsService,
    private helperFunctions: HelperFunctions
  ) {}

  countryName: string
  loading: boolean
  isLoadingVideos: boolean
  isAddingVideo: boolean
  isEditingVideo: boolean
  isDeletingVideo: boolean
  message: string
  videosData: any
  videosDataFilter: any
  page = 1
  count = 10
  searchItem: string
  singleVideoData: any
  videoId: string
  status: string
  model: any
  selectedVideoFile: any = null
  videoUrl: string
  files: any
  duration: string
  progress = 0

  quillConfig = {
    toolbar: [
      ['bold', 'italic', 'underline'],
      [{ list: 'ordered' }, { list: 'bullet' }],
      [{ header: 1 }, { header: 2 }],
      ['clean'],
    ],
  }

  editorStyle = {
    height: '150px',
    marginBottom: '10px',
  }

  ngOnInit() {
    const currentUser = this.authenticationService.getCurrentUserValue()
    const { country } = currentUser
    this.countryName = country
    this.model = {}
    this.loadVideos()
  }

  loadVideos() {
    this.isAddingVideo || this.isEditingVideo || this.isDeletingVideo
      ? (this.isLoadingVideos = false)
      : (this.isLoadingVideos = true)
    this.requestService
      .dash_get(`videos/upload/${this.countryName}`, null)
      .subscribe(
        (res) => {
          this.isLoadingVideos = false
          this.videosData = res.data
          this.videosDataFilter = res.data
        },
        (err) => {
          this.isLoadingVideos = false
          this.message = err.error
        }
      )
  }

  filterVideos(event) {
    this.searchItem = event.target.value
    this.videosData
      ? (this.videosDataFilter = this.videosData.filter(
          (data) =>
            data.title.toLowerCase().indexOf(this.searchItem.toLowerCase()) !==
            -1
        ))
      : null
  }

  processVideo(event) {
    this.progress = 0

    if (<File>event.target.files && <File>event.target.files[0]) {
      const maxFileSize = 32 * 1024 * 1024
      const currentFileSize = event.target.files[0].size

      if (currentFileSize > maxFileSize) {
        const status = 'error'
        const message = 'Please the video size should not be greater than 32mbs'
        this.helperFunctions.displayAlert(message, status)
      } else {
        this.selectedVideoFile = <File>event.target.files[0]

        let videoSrc, videoTag: HTMLVideoElement, duration: number, fileChosen

        if (this.isEditingVideo) {
          document.getElementById('edit-vid-progress').style.display = 'block'
          fileChosen = document.getElementById('file-chosen')
          videoSrc = document.querySelector('#edit-video-source')
          videoTag = document.querySelector('#edit-video-tag')
        } else {
          fileChosen = document.getElementById('chosen-file')
          videoSrc = document.querySelector('#add-video-source')
          videoTag = document.querySelector('#add-video-tag')
        }
        fileChosen.textContent = this.selectedVideoFile.name

        if (!videoSrc || !videoTag) return

        const fileReader: FileReader = new FileReader()

        videoTag.addEventListener('durationchange', () => {
          duration = videoTag.duration
          let minutes = Math.floor(duration / 60) + 'min '
          let seconds = Math.floor(duration % 60) + 'seconds'
          this.duration = minutes + seconds
        })

        fileReader.onload = (event: Event) => {
          let videoUrl: any = fileReader.result
          videoSrc.setAttribute('src', videoUrl)
          videoTag.load()
          videoTag.play()
        }

        fileReader.onprogress = (e) => {
          this.progress = Math.round((e.loaded * 100) / e.total)

          setTimeout(() => {
            if (this.progress === 100) {
              if (this.isEditingVideo) {
                document.getElementById('edit-vid-progress').style.display =
                  'none'
              } else {
                document.getElementById('vid-progress').style.display = 'none'
                document.getElementById('video-display').style.display = 'block'
              }
            }
          }, 1500)
        }

        fileReader.readAsDataURL(event.target.files[0])
      }
    }
  }

  addVideo(addVideoForm) {
    const formData = new FormData()

    formData.append('title', addVideoForm.title)
    formData.append('description', addVideoForm.description)
    formData.append('duration', this.duration)
    if (this.selectedVideoFile) {
      formData.append(
        'video',
        this.selectedVideoFile,
        this.selectedVideoFile.name
      )
    }

    this.loading = true

    this.requestService
      .dash_post(`videos/upload/${this.countryName}`, formData)
      .subscribe(
        (res) => {
          this.loading = false
          if (res.success === true) {
            this.message = res.message
            this.status = 'success'
            this.isAddingVideo = true
            this.loadVideos()
            this.helperFunctions.displayAlert(this.message, this.status)
            this.resetAddVideoModal()
          } else if (res.success === false) {
            this.message = res.message
            this.status = 'error'
            this.helperFunctions.displayAlert(this.message, this.status)
          } else if (res.error) {
            this.message = res.error
            this.status = 'error'
            this.helperFunctions.displayAlert(this.message, this.status)
          }
        },
        (err) => {
          this.loading = false
          this.status = 'error'
          this.message = 'An error occurred. Please try again'
          this.helperFunctions.displayAlert(this.message, this.status)
        }
      )
  }

  resetAddVideoModal() {
    jQuery(document).ready(() => {
      this.loading = false
      this.isAddingVideo = false
      jQuery('#addVideoModal').modal('hide')
      jQuery('#addVideoForm')[0].reset()
      this.selectedVideoFile = null
      jQuery('#add-video-source').attr('src', '')
      jQuery('#add-video-tag')[0].load()
      this.duration = ''
      this.progress = 0
      jQuery('#video-display').css({ display: 'none' })
      jQuery('#vid-progress').css({ display: 'block' })
      jQuery('#chosen-file').text('No file chosen')
    })
  }

  setSingleVideoViewData(data: object, editingStatus) {
    this.isEditingVideo = editingStatus
    this.singleVideoData = data
    this.videoId = this.singleVideoData.id
    let videoUrl: any =
      'https://storage.googleapis.com/ezyagric-media' +
      this.singleVideoData.video_url

    if (this.isEditingVideo) {
      jQuery(document).ready(() => {
        jQuery('#edit-video-source').attr('src', videoUrl)
        jQuery('#edit-video-tag')[0].load()
      })
    }
  }

  editVideo(editVideoForm) {
    this.loading = true
    let formData = new FormData()

    formData.append('title', editVideoForm.title)
    formData.append('description', editVideoForm.description)
    formData.append('duration', this.duration)
    if (this.selectedVideoFile) {
      formData.append(
        'video',
        this.selectedVideoFile,
        this.selectedVideoFile.name
      )
    }

    this.requestService
      .dash_putWithImage(`videos/update/${this.videoId}`, formData)
      .subscribe(
        (res) => {
          this.loading = false
          if (res.success) {
            this.message = res.message
            this.status = 'success'
            this.isEditingVideo = true
            this.loadVideos()
            this.helperFunctions.displayAlert(this.message, this.status)
            this.resetEditVideoModal()
          } else if (!res.success) {
            this.message = res.message
            this.status = 'error'
            this.helperFunctions.displayAlert(this.message, this.status)
          }
        },
        (error) => {
          this.loading = false
          this.status = 'error'
          this.message = 'An error occurred. Please try again'
          this.helperFunctions.displayAlert(this.message, this.status)
        }
      )
  }

  resetEditVideoModal() {
    jQuery(document).ready(() => {
      this.loading = false
      this.isEditingVideo = false
      jQuery('#editVideoModal').modal('hide')
      this.selectedVideoFile = null
      jQuery('#edit-video-source').attr('src', '')
      jQuery('#edit-video-tag')[0].load()
      this.duration = ''
      this.progress = 0
      jQuery('#file-chosen').text('No file chosen')
    })
  }

  deleteVideo(id: string): void {
    this.loading = true
    this.requestService.dash_delete(id, `videos/update`).subscribe(
      (res) => {
        this.loading = false
        this.status = 'success'
        this.isDeletingVideo = true
        this.loadVideos()
        this.message = res.message
        this.helperFunctions.displayAlert(this.message, this.status)
        jQuery(document).ready(() => {
          this.isDeletingVideo = false
          jQuery('#deleteVideoModal').modal('hide')
        })
      },
      (err) => {
        this.loading = false
        if (err.status === 404) {
          this.message = 'Video content not found!'
        } else {
          this.message = 'Some error occurred. Please try again'
          this.status = 'error'
          this.helperFunctions.displayAlert(this.message, this.status)
          jQuery(document).ready(() => {
            this.isDeletingVideo = false
            jQuery('deleteVideoModal').modal('hide')
          })
        }
      }
    )
  }

  onClickOutside() {
    jQuery(document).ready(() => {
      jQuery('#addVideoModal').on('hidden.bs.modal', () => {
        this.resetAddVideoModal()
      })
      jQuery('#editVideoModal').on('hidden.bs.modal', () => {
        this.resetEditVideoModal()
      })
    })
  }
}
